import { render } from "./VUEPopupImpostazioniModulo.vue?vue&type=template&id=0b75a316"
import script from "./VUEPopupImpostazioniModulo.vue?vue&type=script&lang=js"
export * from "./VUEPopupImpostazioniModulo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__